/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Typ připojení zařízení k síti.
 * @enum {string}
 */
const NetworkType = {
  /** Připojení přes pevné ethernet připojení. */
  Ethernet: 'Ethernet',
  /** Připojení přes bezdrátové Wi-Fi připojení. */
  Wifi: 'Wifi'
};

export default NetworkType;
